/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { css } from "styled-components";
import { theme } from "@nordcloud/gnui";

export const interactiveCss = css({
  cursor: "pointer",

  "&:hover": {
    opacity: theme.opacity,
  },
});
